import React from "react";
import Footer from "../components/footer";
import DownloadCTA from "../components/home/download"
import AboutCentria from "../components/about/about"

const AboutUs = () => {
    return (
        <div>
            <AboutCentria />
            {/* <DownloadCTA /> */}
            <Footer />
        </div>
    );
};

export default AboutUs;
